import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import CustomPagination from "../../../PotatoProtection/LargeScreen/Landing/CustomPagination";
import {
  setListOfValueSearch,
  setListOfValuesEndPoint,
  setlistOfValueSideTrayName,
  setSelectedListOfRowValue,
  setSpecialProjectDrawer,
} from "../../../../slices/adminPageSlice";
import { useDispatch, useSelector } from "react-redux";
import useThemeRender from "../../../../theme/useThemeRender";

import { BASE_URL } from "../../../../constant/apiUrl";
import { getAPI, deleteAPI } from "../../../../API/ApiService";
import Loading from "../../../../utils/Loader";
import { Icon } from "pepsico-ds";
import DeleteModal from "../Builder/DeleteModal/DeleteModal";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../utils/Toast/toast";
import { setIpOwnerShip, setFavourite } from "../../../../slices/internalPageSlice";
import { triggerRefetchNav } from "../../../../slices/navSlice";
import {
  setCountryFilter,
  setFlashColorFilter,
  setSectorFilter,
  setLanguageFilter,
  setCropTypeFilter,
  setIpOwnerShipFilter,
  setSectorAndCountry,
} from "../../../../slices/internalFilterSlice";
import { getActiveItems } from "../../../../utils/function";
import { DISCLAIMER, SECTOR_COUNTRY_MAPPING } from "./CONSTANT";

function ListOfValuesTable() {
  const rowsPerPage = 10;
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();

  const { selectedListOfValues, listOfValuesEndPoint, listOfValueSearch } =
    useSelector((store) => store.adminpage);
  const textColorLayer2 = useThemeRender("textColorLayer2");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [OriginalData, setOriginalData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedRowForDelete, setSelectedRowForDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const paginatedData =
    filterData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) ||
    [];
  const { favourite } = useSelector((store) => store.internalPage);
  const handleSelect = (row) => {
    console.log(row, "row");
    dispatch(setSelectedListOfRowValue(row));
    dispatch(setlistOfValueSideTrayName("Edit value"));
    dispatch(setSpecialProjectDrawer(true));
  };

  const handleDeleteClick = (e, row) => {
    e.stopPropagation(); // Prevent row selection when clicking delete
    setSelectedRowForDelete(row);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedRowForDelete) return;

    // Only allow delete for PAGE_GROUP endpoint
    if (listOfValuesEndPoint !== "PAGE_GROUP") {
      showErrorToast("Delete is only available for Page Groups");
      return;
    }

    setDeleteLoading(true);
    try {
      const deleteUrl = `${BASE_URL}/lookup/delete-page-group/${selectedRowForDelete.id}`;
      const response = await deleteAPI(deleteUrl);

      if (response?.status === 200 || response?.status === 204) {
        showSuccessToast("Page Group deleted successfully");
        setDeleteModalOpen(false);
        setSelectedRowForDelete(null);
        dispatch(setFavourite(favourite + 1));
        dispatch(triggerRefetchNav(true));
      } else if (response?.status === 302) {
        showErrorToast(response?.data?.message);
        setDeleteModalOpen(false);
        setSelectedRowForDelete(null);
      } else {
        showErrorToast(
          response?.data?.message || "Failed to delete Page Group"
        );
      }
    } catch (error) {
      console.error("Error deleting Page Group:", error);
      if (error?.response?.status === 302) {
        showErrorToast(error?.response?.data?.message || "Cannot delete Page Group. It may be in use.");
        setDeleteModalOpen(false);
        setSelectedRowForDelete(null);
      } else {
        showErrorToast("An error occurred while deleting the Page Group");
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setSelectedRowForDelete(null);
  };

  useEffect(() => {
    setPage(0);
  }, [listOfValueSearch]);
  useEffect(() => {
    switch (selectedListOfValues) {
      case "Content level":
        dispatch(setListOfValuesEndPoint("CONTENT_LEVEL"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Sector":
        dispatch(setListOfValuesEndPoint("SECTOR"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Country":
        dispatch(setListOfValuesEndPoint("COUNTRY"));
        dispatch(setListOfValueSearch(""));
        break;
      case SECTOR_COUNTRY_MAPPING:
        dispatch(setListOfValuesEndPoint(SECTOR_COUNTRY_MAPPING));
        dispatch(setListOfValueSearch(""));
        break;
      case "Crop type":
        dispatch(setListOfValuesEndPoint("CROP_TYPE"));
        dispatch(setListOfValueSearch(""));
        break;
      case DISCLAIMER:
        dispatch(setListOfValuesEndPoint("DISCLAIMER"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Language":
        dispatch(setListOfValuesEndPoint("LANGUAGE"));
        dispatch(setListOfValueSearch(""));
        break;
      case "IP Ownership":
        dispatch(setListOfValuesEndPoint("IPOWNERSHIP"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Flesh Color":
        dispatch(setListOfValuesEndPoint("FLESH_COLOR"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Organization":
        dispatch(setListOfValuesEndPoint("ORGANIZATION"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Bussiness Unit":
        dispatch(setListOfValuesEndPoint("BUSINESS_UNIT"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Company":
        dispatch(setListOfValuesEndPoint("COMPANY"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Department":
        dispatch(setListOfValuesEndPoint("DEPARTMENT"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Partner Type":
        dispatch(setListOfValuesEndPoint("PARTNER_TYPE"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Period":
        dispatch(setListOfValuesEndPoint("PERIOD"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Reason For Access":
        dispatch(setListOfValuesEndPoint("REASON_FOR_ACCESS"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Region":
        dispatch(setListOfValuesEndPoint("REGION"));
        dispatch(setListOfValueSearch(""));
        break;

      case "Special Projects":
        dispatch(setListOfValuesEndPoint("SPECIAL_PROJECTS"));
        dispatch(setListOfValueSearch(""));
        break;

      case "Visibility":
        dispatch(setListOfValuesEndPoint("VISIBILITY"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Variety":
        dispatch(setListOfValuesEndPoint("VARIETY"));
        dispatch(setListOfValueSearch(""));
        break;
      case "Page Group":
        dispatch(setListOfValuesEndPoint("PAGE_GROUP"));
        dispatch(setListOfValueSearch(""));
        break;
      default:
        break;
    }
  }, [selectedListOfValues, dispatch]);
  const sortSectorCountryData = (data) => {
    return data?.sort((a, b) => {
      const sectorNameA = a?.sector?.name?.toLowerCase() || "z";
      const sectorNameB = b?.sector?.name?.toLowerCase() || "z";

      if (sectorNameA < sectorNameB) return -1;
      if (sectorNameA > sectorNameB) return 1;
      return 0;
    });
  };
  const fetchDataSectorCountryData = async () => {
    try {
      setLoading(true);
      const response = await getAPI(
        `${BASE_URL}/lookup/find-all-country-sector`
      );
      if (response?.status === 200) {
        const sortedData = sortSectorCountryData(response?.data?.response);
        setOriginalData(sortedData);
        setFilterData(sortedData);
        dispatch(setSectorAndCountry(sortedData));
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const sortOtherLOV = (data) => {
    return data?.sort((a, b) => {
      const nameA = a?.name?.toLowerCase();
      const nameB = b?.name?.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  };
  const fetchOtherLOVData = async () => {
    try {
      setLoading(true);
      const response = await getAPI(
        `${BASE_URL}/lookup/find-all?lookUpTypes=${listOfValuesEndPoint}`
      );
      if (response?.status === 200) {
        const sortedData = sortOtherLOV(
          response?.data?.response?.[listOfValuesEndPoint]
        );
        const activeItems = getActiveItems(
          response?.data?.response?.[listOfValuesEndPoint]
        );
        if (listOfValuesEndPoint === "LANGUAGE") {
          dispatch(setLanguageFilter(activeItems));
        }
        if (listOfValuesEndPoint === "SECTOR") {
          dispatch(setSectorFilter(activeItems));
        }
        if (listOfValuesEndPoint === "COUNTRY") {
          dispatch(setCountryFilter(activeItems));
        }

        if (listOfValuesEndPoint === "IPOWNERSHIP") {
          dispatch(setIpOwnerShipFilter(activeItems));
          dispatch(setIpOwnerShip(activeItems));
        }

        if (listOfValuesEndPoint === "FLESH_COLOR") {
          dispatch(setFlashColorFilter(activeItems));
        }
        if (listOfValuesEndPoint === "CROP_TYPE") {
          dispatch(setCropTypeFilter(activeItems));
        }

        setOriginalData(sortedData);
        setFilterData(sortedData);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING) {
      fetchDataSectorCountryData();
    } else if (listOfValuesEndPoint !== "") {
      fetchOtherLOVData();
    }
  }, [listOfValuesEndPoint, favourite]);

  useEffect(() => {
    if (listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING) {
      const filtered = OriginalData?.filter(
        (row) =>
          row?.name
            ?.toLowerCase()
            ?.includes(listOfValueSearch?.toLowerCase()) ||
          row?.sector?.name
            ?.toLowerCase()
            ?.includes(listOfValueSearch?.toLowerCase())
      );
      setFilterData(filtered);
    } else {
      const filtered = OriginalData?.filter(
        (row) =>
          row?.name
            ?.toLowerCase()
            ?.includes(listOfValueSearch?.toLowerCase()) ||
          row?.description
            ?.toLowerCase()
            ?.includes(listOfValueSearch?.toLowerCase())
      );
      setFilterData(filtered);
    }
  }, [listOfValueSearch]);
  const cardBackgroundColorLayer1 = useThemeRender("cardBackgroundColorLayer1");

  if (loading) return <Loading />;
  return (
    <>
      <DeleteModal
        open={deleteModalOpen}
        setClose={handleDeleteCancel}
        handleDelete={handleDeleteConfirm}
        title="Delete Page Group"
        text="Are you sure you want to delete this Page Group? This action cannot be undone."
        loading={deleteLoading}
      />
      <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        borderTop: "2px solid #D7E5F8",
        background: cardBackgroundColorLayer1,
      }}
    >
      <Table>
        <TableHead>
          <TableRow
            sx={{
              borderBottom: "2px solid #D7E5F8",
            }}
          >
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                borderBottom: "2px solid #D7E5F8",
                color: textColorLayer2,
              }}
            >
              {listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING
                ? "Sector"
                : "Name"}
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                borderBottom: "2px solid #D7E5F8",
                color: textColorLayer2,
              }}
            >
              {listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING
                ? "Country"
                : "Description"}
            </TableCell>
            <TableCell
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                borderBottom: "2px solid #D7E5F8",
                color: textColorLayer2,
              }}
            >
              Status
            </TableCell>
            {listOfValuesEndPoint === "PAGE_GROUP" && (
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  borderBottom: "2px solid #D7E5F8",
                  color: textColorLayer2,
                  textAlign: "center",
                }}
              >
                Action
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData?.map((row) => (
            <TableRow
              key={row.id}
              sx={{
                "&:last-child td": { borderBottom: "none" },
                borderBottom: "2px solid #D7E5F8",
                cursor: "pointer",
              }}
              onClick={() => handleSelect(row)}
            >
              <TableCell
                sx={{
                  color: textColorLayer2,
                  fontSize: "14px",
                  borderBottom: "2px solid #D7E5F8",
                }}
              >
                {listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING
                  ? row?.sector?.name
                  : row?.name}
              </TableCell>
              <TableCell
                sx={{
                  color: textColorLayer2,
                  fontSize: "14px",
                  borderBottom: "2px solid #D7E5F8",
                }}
              >
                {listOfValuesEndPoint === SECTOR_COUNTRY_MAPPING
                  ? row?.name
                  : row?.description}
              </TableCell>
              <TableCell
                sx={{
                  color: textColorLayer2,
                  fontSize: "14px",
                  borderBottom: "2px solid #D7E5F8",
                }}
              >
                {row?.active ? "Active" : "Inactive"}
              </TableCell>
              {listOfValuesEndPoint === "PAGE_GROUP" && (
                <TableCell
                  sx={{
                    color: textColorLayer2,
                    fontSize: "14px",
                    borderBottom: "2px solid #D7E5F8",
                    textAlign: "center",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon
                      alt="delete"
                      icon="delete"
                      size="medium"
                      style={{ color: "#005cbc", cursor: "pointer" }}
                      onClick={(e) => handleDeleteClick(e, row)}
                    />
                  </Box>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          background: "#FFF",
        }}
      >
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={Math.ceil(filterData?.length / rowsPerPage)}
        />
      </Box>
    </TableContainer>
    </>
  );
}

export default ListOfValuesTable;
